import MembershipLengthByAgreementModule from "./MembershipLengthModule";
import MembershipLengthByAgreementSagas from "./redux/membershipLengthSagas";
import MembershipLengthByAgreementReducers from "./redux/membershipLengthReducer";

export default {
  Component: MembershipLengthByAgreementModule,
  moduleName: "membershipLengthByAgreement",
  saga: MembershipLengthByAgreementSagas(),
  reducer: MembershipLengthByAgreementReducers
};
